import { CANtrackCommentRaw } from 'api/comments/getComments';
import { CANtrackComment } from '../types/comment';
import { customDateParser } from 'libs/utils/customDateParser';

export function convertToCANtrackComment(
	raw: CANtrackCommentRaw,
): CANtrackComment {
	return {
		id: parseInt(raw.Id),
		title: raw.TaskTitle,
		description: raw.Description,
		date: customDateParser(raw.EntryDate),
		timeRegular: parseFloat(raw.TimeRegular),
		timeOver: parseFloat(raw.TimeOver),
		caseID: parseInt(raw.CaseId),
		caseTitle: raw.CaseTitle,
		customerID: parseInt(raw.CustomerId),
		customerName: raw.CustomerName,
		gpda: {
			group: {
				id: parseInt(raw.GroupId),
				title: raw.GroupTitle,
			},
			project: {
				id: parseInt(raw.ProjectId),
				title: raw.ProjectTitle,
			},
			deliverable: {
				id: parseInt(raw.DeliverableId),
				title: raw.DeliverableTitle,
			},
			activity: {
				id: parseInt(raw.ActivityId),
				title: raw.ActivityTitle,
			},
		},
		billable: raw.Billable === 'Y',
		consultantId: raw.ConsultantId ? parseInt(raw.ConsultantId) : undefined,
		consultantName: raw.ConsultantName || undefined,
	};
}
